import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'

const GlobalError = () => {
    return (
        <Container sx={{ marginTop: 4, marginBottom: 2 }} maxWidth={false}>
            <Grid
                container
                spacing={2}
                size={12}
                sx={{
                    display: 'flex',
                    justifyContent: 'stretch',
                    backgroundColor: 'primary.main',
                }}
            >
                <Grid
                    size={12}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Typography>
                        <span role="img" aria-label="sad face" style={{ fontSize: 72 }}>
                            😭
                        </span>
                    </Typography>
                </Grid>
                <Grid
                    size={12}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Typography variant="h2" color="white">
                        An error occurred
                    </Typography>
                </Grid>
                <Grid
                    size={12}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Typography variant="h5" color="white">
                        This part of Mockingbird could not be loaded. Please inform support or try
                        again.
                    </Typography>
                </Grid>
                <Grid
                    size={12}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Link href="/" variant="h6" underline="none" sx={{ color: 'white' }}>
                        Click here to return to the start page.
                    </Link>
                </Grid>
            </Grid>
        </Container>
    )
}

export default GlobalError
